import React from 'react';
import './Nosotros.css';

const stats = [
  { num: '+1,000',     desc: 'Clientes satisfechos' },
  { num: '5+',         desc: 'Años de trayectoria' },
  { num: 'S/. 200,000', desc: 'En montos desembolsados' },
  { num: '0',          desc: 'Costos ocultos. Todo transparente' },
];

const Nosotros = () => (
  <section id="nosotros" className="nosotros">
    <div className="nosotros__grid">
      <div className="nosotros__text">
        <div className="eyebrow">Sobre nosotros</div>
        <h2 className="section-title nosotros__heading">
          Transparencia y respaldo para tu familia
        </h2>
        <p className="nosotros__body">
          En Cash Sol SAC entendemos que una oportunidad no puede esperar. Por eso,
          hemos simplificado el acceso al crédito bancario tradicional, ofreciendo
          condiciones justas y seguras.
        </p>
        <ul className="nosotros__list">
          <li><span className="req-check">✓</span> Tasación certificada de bienes</li>
          <li><span className="req-check">✓</span> Registro oficial ante la SBS</li>
          <li><span className="req-check">✓</span> Custodia en bóvedas de alta seguridad</li>
        </ul>
      </div>

      <div className="nosotros__stats-grid">
        {stats.map((s) => (
          <div className="nos-stat" key={s.num}>
            <div className="nos-stat__num">{s.num}</div>
            <p>{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Nosotros;
